export default "__VITE_ASSET__BJYgx0L$__"